import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../Text'
import Image from '../Image'
import CheckboxSelected from '../icons/svg/check-box-selected.svg'
import CheckboxUnselected from '../icons/svg/check-box-unselected.svg'
import CheckboxError from '../icons/svg/check-box-error.svg'

const CheckboxInput = styled.input`
  display: none;
`
const Label = styled.label`
  display: flex;
  cursor: pointer;
`

const Content = styled.div`
  width: 95%;
  padding-left: 0.5rem;
`

const generateCheckBox = ({ invalid, checked }) => {
  if (invalid) {
    return (
      <Image
        data-testid="invalid"
        src={CheckboxError}
        reservedWidth="1.2rem"
        reservedHeight="1.2rem"
      />
    )
  }

  return checked ? (
    <Image
      data-testid="checked"
      src={CheckboxSelected}
      reservedWidth="1.2rem"
      reservedHeight="1.2rem"
    />
  ) : (
    <Image
      data-testid="unchecked"
      src={CheckboxUnselected}
      reservedWidth="1.2rem"
      reservedHeight="1.2rem"
    />
  )
}

class CheckBox extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    if (e.target.value === 'true') {
      e.target.value = 'false'
    } else {
      e.target.value = 'true'
    }
    this.props.onChange && this.props.onChange(e.target.value === 'true')
  }

  render() {
    const { name, value, inlineLabel, invalid, checked } = this.props
    return (
      <>
        <CheckboxInput
          type="checkbox"
          name={name}
          value={value}
          id={name}
          onChange={this.handleChange}
          checked={checked}
          data-testid={this.props['data-testid'] || 'checkbox'}
        />
        <Label htmlFor={name}>
          {generateCheckBox({ checked: checked, invalid })}
          <Content>
            <Text as="p">{inlineLabel}</Text>
            {invalid && (
              <Text as="p" size="small" color="#dd0d42" margin="0.2rem 0 0 0">
                {invalid}
              </Text>
            )}
          </Content>
        </Label>
      </>
    )
  }
}

export default CheckBox
